/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesAchievementDefinitionSchema } from "./achievementDefinitionSchema.ts";
import { goodLuckCoreEntitiesAchievementRaritySchema } from "./achievementRaritySchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesAchievementProgressTierSchema = z.object({
  id: z.optional(z.int()),
  achievementDefinitionId: z.int(),
  get achievementDefinition() {
    return goodLuckCoreEntitiesAchievementDefinitionSchema.optional();
  },
  order: z.optional(z.int()),
  requiredValue: z.optional(z.int()),
  title: z.string().min(1).max(100),
  description: z.string().min(1).max(500),
  iconUrl: z.string().min(1),
  get rarity() {
    return goodLuckCoreEntitiesAchievementRaritySchema.optional();
  },
});
